package org.example.project.enginemodule

import org.example.project.service.ZustandManager
import org.example.project.utils.All

fun deriveShopModuleState(module: ShopModuleMeta): ModuleState = when {
    module.globalState == ZustandManager.Modul.WARTUNG -> ModuleStateVal.MAINTENANCE
    module.globalState == ZustandManager.Modul.State.GESPERRT -> ModuleStateVal.BLOCKED
    module.enabledScreens.isEmpty() -> ModuleStateVal.DISABLED
    module.installed && module.updateAvailable -> ModuleStateVal.UPDATE_AVAILABLE
    module.installed -> ModuleStateVal.INSTALLED
    module.purchased -> ModuleStateVal.PURCHASED
    else -> ModuleStateVal.AVAILABLE
}

fun canInstallShopModule(module: ShopModuleMeta, currentState: ModuleState?): Boolean {
    if (module.enabledScreens.isEmpty()) return false
    return currentState == ModuleStateVal.AVAILABLE
}

fun canDeactivateShopModule(module: ShopModuleMeta, currentState: ModuleState?): Boolean {
    if (module.globalState == ZustandManager.Modul.WARTUNG) return false
    if (module.globalState == ZustandManager.Modul.State.GESPERRT) return false
    return currentState != ModuleStateVal.INSTALLING && currentState != ModuleStateVal.UNINSTALLING
}

fun canActivateShopModule(module: ShopModuleMeta): Boolean {
    if (module.globalState == ZustandManager.Modul.WARTUNG) return false
    if (module.globalState == ZustandManager.Modul.State.GESPERRT) return false
    return module.enabledScreens.isNotEmpty()
}

suspend fun persistShopModuleState(
    module: ShopModuleMeta,
    nextState: Int,
    applyLatestModuleData: Boolean = false,
    markPurchased: Boolean = false
): Map<Int, All> {
    return ModuleApi.saveCustomerModuleState(
        moduleId = module.moduleId,
        nextState = nextState,
        applyLatestModuleData = applyLatestModuleData,
        markPurchased = markPurchased
    )
}
